/** @file pairMirror: pairs the first two selected nodes as mirror twins, or says how to. */
import type { EditorStore } from '../../state/editorTypes';

/** With two nodes selected dispatches `node.mirrorPair { node, twin }`; otherwise shows a hint and dispatches nothing. */
export function pairMirror(store: EditorStore): void {
  const s = store.getState();
  const [node, twin] = s.selection.nodes;
  if (node === undefined || twin === undefined) {
    s.notify('info', 'Select a node and Ctrl+click its twin, then pair them');
    return;
  }
  void s.dispatch([{ name: 'node.mirrorPair', input: { node, twin } }], `mirror ${node} <-> ${twin}`);
}
